/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */

import { Client } from 'external/lwr-client';

const servicePath = '/geo.geofeature/';
const method = 'search-viewable-by-class-names-scope-group.5';

export default {

    getGeoJson(query) {
        return Client.invokeWithContext(servicePath + method, query, {});
    },

    getExternalGeoJson(url) {
        return fetch(url).then(response => response.json());
    }

};



// WEBPACK FOOTER //
// ./js/webapi/GeoJsonWebApi.js